'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'components/consumer/Checkbox';
const DEFAULT_LIMIT = 6;
const CategoryFacetFilter = t0 => {
  const $ = _c(31);
  const {
    attribute,
    label,
    options,
    selectedValues,
    onToggle
  } = t0;
  const [showMore, setShowMore] = useState(false);
  let t1;
  if ($[0] !== options || $[1] !== selectedValues) {
    let t2;
    if ($[3] !== selectedValues) {
      t2 = option => ({
        id: option.id,
        label: option.label,
        isRefined: selectedValues.has(option.id)
      });
      $[3] = selectedValues;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = options.map(t2);
    $[0] = options;
    $[1] = selectedValues;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const enrichedOptions = t1;
  let t2;
  if ($[5] !== enrichedOptions || $[6] !== showMore) {
    t2 = showMore ? enrichedOptions : enrichedOptions.slice(0, DEFAULT_LIMIT);
    $[5] = enrichedOptions;
    $[6] = showMore;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const displayedOptions = t2;
  const hasMore = enrichedOptions.length > DEFAULT_LIMIT;
  let t3;
  if ($[8] !== attribute || $[9] !== onToggle) {
    t3 = option_0 => {
      onToggle(attribute, option_0.id);
    };
    $[8] = attribute;
    $[9] = onToggle;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleToggle = t3;
  if (enrichedOptions.length === 0) {
    return null;
  }
  let t4;
  if ($[11] !== label) {
    t4 = <h3 className="text-base font-bold mb-2">{label}</h3>;
    $[11] = label;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== attribute || $[14] !== displayedOptions || $[15] !== handleToggle) {
    let t6;
    if ($[17] !== attribute || $[18] !== handleToggle) {
      t6 = option_1 => <li key={option_1.id} className="cursor-pointer mt-3"><Checkbox id={`${attribute}-${option_1.id}`} checked={option_1.isRefined} onClick={() => handleToggle(option_1)} size="sm" className="group flex relative cursor-pointer"><span className="[&_a]:text-brand [&_a]:z-[2] [&_a]:focus:underline group-hover:text-brand text-gray pl-1 text-sm mt-px">{option_1.label}</span></Checkbox></li>;
      $[17] = attribute;
      $[18] = handleToggle;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    t5 = displayedOptions.map(t6);
    $[13] = attribute;
    $[14] = displayedOptions;
    $[15] = handleToggle;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[20] !== t5) {
    t6 = <ul className="list-none p-0 m-0">{t5}</ul>;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== hasMore || $[23] !== showMore) {
    t7 = hasMore && <button type="button" onClick={() => setShowMore(!showMore)} className="text-sm font-bold text-brand mt-3 bg-transparent border-0 cursor-pointer p-0 font-sans">{showMore ? "View Less" : "View More"}</button>;
    $[22] = hasMore;
    $[23] = showMore;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t6 || $[26] !== t7) {
    t8 = <div className="[&_.group>span:first-of-type]:rounded">{t6}{t7}</div>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t4 || $[29] !== t8) {
    t9 = <div data-xc="CategoryFacetFilter">{t4}{t8}</div>;
    $[28] = t4;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
CategoryFacetFilter.propTypes = {
  attribute: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  selectedValues: PropTypes.instanceOf(Set).isRequired,
  onToggle: PropTypes.func.isRequired
};
export default CategoryFacetFilter;